import React, { useEffect, useState, useRef } from "react";
import { LuMailCheck } from "react-icons/lu";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CircularProgress, TextField } from "@mui/material";
import UTurnLeftIcon from "@mui/icons-material/UTurnLeft";
import ArrayStepper from "../../../utils/Stepper/ArrayStepper";
import CardSkeletonTrackingDetail from "../../../store/CardSkeletonTrackingDetail.js";
import { BsArrowLeftCircle } from "react-icons/bs";
import styles from "./TicketDetails.module.css";
import tabStyles from "../../MarketPlace/MarketPlaceDetail/MarketPlaceDetail.module.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";

const TrackingDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const { trackingId } = params;

  const orders = location.state?.orders || "";
  const item = location.state?.item || "";
  const index = location.state?.index || "";
  const orderType = location.state?.type || "";
  console.log("orderType", orderType);

  const [isPageLoading, setIsPageLoading] = useState(false);

  //SELECTED CARD STATES:
  const [selectedId, setSelectedId] = useState();
  const [selectedData, setSelectedData] = useState(null);
  //SELECTED CART COLOR STATES :
  const [showSelectedColor, setShowSelectedColor] = useState(false);
  const liRef = useRef(null);
  const ulRef = useRef(null);
  //STATUS DATA:
  // const statusData = JSON.parse(import.meta.env.VITE_STATUS_DATA);
  //STATE FOR REPLY FUNCTION :

  const [trackingStatus, setTrackingStatus] = useState([]);
  const [threadData, setThreadData] = useState([]);
  const [threadLoading, setThreadLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [replyValue, setReplyValue] = useState("");
  const [selectedThread, setSelectedThread] = useState("");
  const [isSomethingChanged, setIsSomethingChanged] = React.useState(false);
  const [selectedTicket, setSelectedTicket] = useState("");
  const [coupon, setCoupon] = useState("");

  const [showUnitPrice, setShowUnitprice] = useState(false);
  const [unitPrices, setUnitPrices] = useState([]);
  const [showError, setShowError] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusError, setStatusError] = useState("");
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendorSelection, setVendorSelection] = useState({});
  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorActionLoading, setVendorActionLoading] = useState({});
  const [vendorError, setVendorError] = useState("");
  const [vendorSuccess, setVendorSuccess] = useState("");
  const [confirmVendorDialogOpen, setConfirmVendorDialogOpen] = useState(false);
  const [pendingVendorItem, setPendingVendorItem] = useState(null);
  const [confirmProceedDialogOpen, setConfirmProceedDialogOpen] = useState(false);
  const [proceedLoading, setProceedLoading] = useState(false);
  const [proceedMessage, setProceedMessage] = useState("");
  const [isVendorForwarded, setIsVendorForwarded] = useState(false);

  const getValue = (obj, keys, fallback = "") => {
    for (const key of keys) {
      if (obj?.[key] !== undefined && obj?.[key] !== null) return obj[key];
    }
    return fallback;
  };

  const getVendorItemKey = (itemObj, fallbackIndex = 0) => {
    const orderItemId = getValue(itemObj, ["order_item_id", "orderItemId"], "");
    const skuId = getValue(itemObj, ["sku_id", "skuId"], "");
    return String(orderItemId || skuId || fallbackIndex);
  };

  const normalizeVendorOptions = (res) => {
    const hasTopLevelVendors = Array.isArray(res?.vendors);
    const items = hasTopLevelVendors
      ? [
          {
            order_item_id: getValue(res, ["order_item_id", "orderItemId"], null),
            sku_id: getValue(res, ["sku_id", "skuId"], ""),
            price_id: getValue(res, ["price_id", "priceId"], ""),
            assigned_vendor_id: getValue(
              res,
              ["assigned_vendor_id", "assignedVendorId"],
              null,
            ),
            default_vendor_id: getValue(
              res,
              ["default_vendor_id", "defaultVendorId"],
              null,
            ),
            vendors: res.vendors,
          },
        ]
      : Array.isArray(res?.items)
        ? res.items
        : [];

    return items.map((item, index) => {
      const vendors = Array.isArray(item?.vendors) ? item.vendors : [];
      const assignedVendorId = getValue(
        item,
        ["assigned_vendor_id", "assignedVendorId"],
        null,
      );
      const defaultVendorId = getValue(
        item,
        ["default_vendor_id", "defaultVendorId"],
        null,
      );
      const effectiveAssignedVendorId =
        assignedVendorId === null || assignedVendorId === undefined
          ? defaultVendorId
          : assignedVendorId;

      return {
        key: getVendorItemKey(item, index),
        order_item_id: getValue(item, ["order_item_id", "orderItemId"], null),
        sku_id: getValue(item, ["sku_id", "skuId"], ""),
        price_id: getValue(item, ["price_id", "priceId"], ""),
        assigned_vendor_id: Number(
          effectiveAssignedVendorId === null ||
            effectiveAssignedVendorId === undefined
            ? 0
            : effectiveAssignedVendorId,
        ),
        default_vendor_id: Number(
          defaultVendorId === null || defaultVendorId === undefined
            ? 0
            : defaultVendorId,
        ),
        vendors: vendors.map((vendor, vIndex) => {
          const vendorId = Number(getValue(vendor, ["vendor_id", "vendorId"], 0));
          return {
            key: String(
              getValue(vendor, ["vendor_id", "vendorId"], `${index}-${vIndex}`),
            ),
            vendor_id: vendorId,
            vendor_name:
              vendorId === -1
                ? "Admin-owned"
                : getValue(
                    vendor,
                    ["vendor_name", "vendorName"],
                    `Vendor ${vIndex + 1}`,
                  ),
            is_default:
              getValue(vendor, ["is_default", "isDefault"], false) ||
              vendorId === Number(defaultVendorId),
            unit_prices: Array.isArray(vendor?.unit_prices)
              ? vendor.unit_prices
              : [],
          };
        }),
      };
    });
  };

  const normalizeUnitIdsFromResponse = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_error) {
        return [];
      }
    }
    return [];
  };

  const fetchVendorOptions = async (orderId) => {
    if (!orderId || orderType !== "need_admin_approval") return;
    try {
      setVendorLoading(true);
      setVendorError("");
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/admin/orders/${orderId}/vendor-options`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      if (!response.ok || !data?.success) {
        throw new Error(data?.message || "Unable to fetch vendor options");
      }
      const normalized = normalizeVendorOptions(data);
      const defaultSelection = {};
      normalized.forEach((item) => {
        defaultSelection[item.key] = String(item.assigned_vendor_id || "");
      });
      setVendorOptions(normalized);
      setVendorSelection(defaultSelection);
      setIsVendorForwarded(
        Boolean(
          getValue(data, ["vendor_forwarded", "is_vendor_forwarded"], false),
        ),
      );
      const responseUnitIds = normalizeUnitIdsFromResponse(
        getValue(data, ["unit_ids", "order_unit_ids"], null),
      );
      if (responseUnitIds.length) {
        setSelectedData((prev) =>
          prev ? { ...prev, unit_ids: responseUnitIds } : prev,
        );
      }
      return data;
    } catch (error) {
      setVendorOptions([]);
      setVendorSelection({});
      setVendorError(error?.message || "Unable to fetch vendor options");
      return null;
    } finally {
      setVendorLoading(false);
    }
  };

  const handleVendorSelectionChange = (itemKey, vendorId) => {
    setVendorSelection((prev) => ({ ...prev, [itemKey]: vendorId }));
    setVendorSuccess("");
    setVendorError("");
  };

  const handleOpenVendorConfirm = (vendorItem) => {
    const selectedVendorId = Number(vendorSelection[vendorItem.key] || 0);
    const currentVendorId = Number(vendorItem.assigned_vendor_id || 0);
    if (selectedVendorId && selectedVendorId === currentVendorId) {
      setVendorError("Selected vendor is already assigned to this order.");
      return;
    }
    setPendingVendorItem(vendorItem);
    setConfirmVendorDialogOpen(true);
  };

  const handleCloseVendorConfirm = () => {
    setConfirmVendorDialogOpen(false);
    setPendingVendorItem(null);
  };

  const handleChangeVendor = async (vendorItem) => {
    if (isVendorForwarded) {
      setVendorError(
        "Vendor assignment is locked because this order is already forwarded to vendor portal.",
      );
      return false;
    }
    const rawSelectedVendorId = vendorSelection[vendorItem.key];
    if (
      !selectedData?.id ||
      rawSelectedVendorId === "" ||
      rawSelectedVendorId === null ||
      rawSelectedVendorId === undefined
    ) {
      return false;
    }
    const selectedVendorId = Number(rawSelectedVendorId);
    const currentVendorId = Number(vendorItem.assigned_vendor_id || 0);
    if (selectedVendorId === currentVendorId) {
      setVendorError("Selected vendor is already assigned to this order.");
      return false;
    }
    try {
      setVendorActionLoading((prev) => ({ ...prev, [vendorItem.key]: true }));
      setVendorError("");
      setVendorSuccess("");

      const payload = { vendor_id: selectedVendorId };
      const selectedVendor = getSelectedVendorForItem(vendorItem);
      const updatedUnitIds = buildUnitIdPayload(
        selectedVendor?.unit_prices || [],
        selectedData?.unit_ids,
      );
      payload.unit_ids = updatedUnitIds;

      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/admin/orders/${selectedData.id}/change-vendor`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();
      if (!response.ok || !data?.success) {
        throw new Error(data?.message || "Unable to change vendor");
      }

      setVendorSuccess("Vendor updated successfully.");
      setSelectedData((prev) =>
        prev ? { ...prev, unit_ids: updatedUnitIds } : prev,
      );
      fetchVendorOptions(selectedData.id);
      return true;
    } catch (error) {
      setVendorError(error?.message || "Unable to change vendor");
      return false;
    } finally {
      setVendorActionLoading((prev) => ({ ...prev, [vendorItem.key]: false }));
    }
  };

  const handleConfirmVendorChange = async () => {
    if (!pendingVendorItem) return;
    const updated = await handleChangeVendor(pendingVendorItem);
    if (updated) {
      handleCloseVendorConfirm();
    }
  };

  const handleProceedToVendor = async () => {
    if (!selectedData?.id) return;
    try {
      setProceedLoading(true);
      setVendorError("");
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/admin/orders/${selectedData.id}/proceed-to-vendor`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            orderId: selectedData.id,
          }),
        },
      );
      const data = await response.json();
      if (!response.ok || !data?.success) {
        throw new Error(data?.message || "Unable to proceed order to vendor");
      }
      const refreshed = await fetchVendorOptions(selectedData.id);
      const forwardedFromServer = Boolean(
        getValue(refreshed || {}, ["vendor_forwarded", "is_vendor_forwarded"], false),
      );
      setIsVendorForwarded(forwardedFromServer);
      if (!forwardedFromServer) {
        throw new Error(
          "Proceed API returned success but order is not marked forwarded in database.",
        );
      }
      setProceedMessage(data?.message || "Order forwarded to vendor portal.");
    } catch (error) {
      setProceedMessage("");
      setVendorError(error?.message || "Unable to proceed order to vendor");
    } finally {
      setProceedLoading(false);
    }
  };

  const handleOpenProceedConfirm = () => {
    if (isVendorForwarded) return;
    setConfirmProceedDialogOpen(true);
  };

  const handleCloseProceedConfirm = () => {
    if (proceedLoading) return;
    setConfirmProceedDialogOpen(false);
  };

  const handleConfirmProceedToVendor = async () => {
    await handleProceedToVendor();
    setConfirmProceedDialogOpen(false);
  };

  const getSelectedVendorForItem = (vendorItem) => {
    const selectedId = Number(vendorSelection[vendorItem.key] || 0);
    return (
      vendorItem.vendors.find((vendor) => Number(vendor.vendor_id) === selectedId) ||
      null
    );
  };

  const getVendorNameFromId = (vendors, vendorId) => {
    const normalizedId = Number(vendorId);
    if (normalizedId === -1) return "Admin-owned";
    return (
      vendors.find((v) => Number(v.vendor_id) === normalizedId)?.vendor_name ||
      "N/A"
    );
  };

  const pickUnitValue = (unit, keys, fallback) => {
    for (const key of keys) {
      if (unit?.[key] !== undefined && unit?.[key] !== null) return unit[key];
    }
    return fallback;
  };

  const getOrderQuantity = () => {
    const rawQty = getValue(
      selectedData,
      ["quantity", "noOfLicences", "no_of_licences", "license_count"],
      0,
    );
    const qty = Number(rawQty);
    return Number.isFinite(qty) && qty > 0 ? qty : 0;
  };

  const getOrderUnitPriceType = () =>
    String(
      getValue(selectedData, ["unit_price_type", "unitPriceType"], "Partial"),
    ).trim();

  const getApplicableUnitsByQuantity = (units = [], quantity = 0, type = "Partial") => {
    const sorted = [...units].sort(
      (a, b) =>
        Number(pickUnitValue(a, ["start_range", "StartRange"], 0)) -
        Number(pickUnitValue(b, ["start_range", "StartRange"], 0)),
    );
    if (!sorted.length || !quantity) return [];

    const rangeIndex = sorted.findIndex((unit) => {
      const start = Number(pickUnitValue(unit, ["start_range", "StartRange"], 0));
      const end = Number(pickUnitValue(unit, ["end_range", "EndRange"], 0));
      return quantity >= start && quantity <= end;
    });

    if (rangeIndex === -1) return [];
    if (String(type).toLowerCase() === "partial") {
      return sorted.filter((_, index) => index <= rangeIndex);
    }
    return [sorted[rangeIndex]];
  };

  const buildUnitIdPayload = (sourceUnits = [], baseUnits = []) => {
    const safeSourceUnits = Array.isArray(sourceUnits) ? sourceUnits : [];
    const safeBaseUnits = Array.isArray(baseUnits) ? baseUnits : [];
    const orderQuantity =
      getOrderQuantity() ||
      Number(
        pickUnitValue(safeSourceUnits?.[0], ["start_range", "StartRange"], 0),
      );
    const unitPriceType = getOrderUnitPriceType();
    const applicableUnits = getApplicableUnitsByQuantity(
      safeSourceUnits,
      orderQuantity,
      unitPriceType,
    );

    return applicableUnits.map((unit, index) => {
      const sourceUnitId = Number(pickUnitValue(unit, ["id", "unit_id"], 0));
      const matchedBase =
        safeBaseUnits.find(
          (base) =>
            Number(pickUnitValue(base, ["id", "unit_id"], 0)) === sourceUnitId,
        ) || safeBaseUnits[index];

      const startRange = Number(
        pickUnitValue(unit, ["start_range", "StartRange"], 0),
      );
      const endRange = Number(pickUnitValue(unit, ["end_range", "EndRange"], 0));
      const vendorPrice = Number(
        pickUnitValue(unit, ["vendor_price", "Vendor_price"], 0),
      );
      const marketplacePrice = Number(
        pickUnitValue(unit, ["marketplace_price", "Marketplace_price"], 0),
      );
      const minPrice = Number(pickUnitValue(unit, ["min_price", "Min_price"], 0));
      const maxPrice = Number(pickUnitValue(unit, ["max_price", "Max_price"], 0));
      const unitQuantity =
        String(unitPriceType).toLowerCase() === "partial"
          ? index === applicableUnits.length - 1
            ? orderQuantity - startRange + 1
            : endRange - startRange + 1
          : orderQuantity;
      const unitTotal = Number(unitQuantity * marketplacePrice).toFixed(2);

      if (!matchedBase || typeof matchedBase !== "object") {
        return {
          id: sourceUnitId || index + 1,
          start_range: startRange,
          end_range: endRange,
          vendor_price: vendorPrice,
          marketplace_price: marketplacePrice,
          min_price: minPrice,
          max_price: maxPrice,
          quantity: unitQuantity,
          total: unitTotal,
        };
      }

      return {
        ...matchedBase,
        id: sourceUnitId || pickUnitValue(matchedBase, ["id", "unit_id"], index + 1),
        start_range: startRange,
        end_range: endRange,
        vendor_price: vendorPrice,
        marketplace_price: marketplacePrice,
        min_price: minPrice,
        max_price: maxPrice,
        quantity: unitQuantity,
        total: unitTotal,
      };
    });
  };

  const fetchCouponPercent = async (orderItem) => {
    if (!orderItem?.coupon) {
      setCoupon(0);
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/check_coupon`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            region: orderItem.region === "IN" ? 1 : 2,
            coupon: orderItem.coupon,
          }),
        },
      );
      const res = await response.json();
      if (res.status) {
        setCoupon(Number(res.coupon || 0));
      } else {
        setCoupon(0);
      }
    } catch (_error) {
      setCoupon(0);
    }
  };

  useEffect(() => {
    getThreads(trackingId);
    if (item) {
      setSelectedData(item);
      setSelectedStatus("");
      cardSelectedHandler(item);
      setSelectedTicket(item.ticket_id);
      if (orderType === "need_admin_approval") {
        fetchCouponPercent(item);
        fetchVendorOptions(item.id);
      }
    }

    if (item === "") {
      navigate("/dashboard/order_approval");
    }

    // eslint-disable-next-line
  }, [trackingId]);

  useEffect(() => {
    if (liRef.current && ulRef.current) {
      const heightOfLiElement = liRef.current.clientHeight;
      const totalHeightToScroll = heightOfLiElement * index;

      ulRef.current.scrollTo({
        top: totalHeightToScroll,
        behavior: "smooth",
      });
    }
  }, [index]);

  const handleOpen = async (prices) => {
    if (isVendorForwarded) {
      setVendorError(
        "Price updates are locked because this order is already forwarded to vendor portal.",
      );
      return;
    }
    let latestUnitIds = [];
    let latestVendorOptions = [];
    if (orderType === "need_admin_approval" && selectedData?.id) {
      const latest = await fetchVendorOptions(selectedData.id);
      latestUnitIds = normalizeUnitIdsFromResponse(
        getValue(latest || {}, ["unit_ids", "order_unit_ids"], []),
      );
      latestVendorOptions = normalizeVendorOptions(latest || {});
    }
    const selectedDataUnitIds = normalizeUnitIdsFromResponse(selectedData?.unit_ids);
    const incomingPrices = normalizeUnitIdsFromResponse(prices);
    let derivedFromVendor = [];
    if (!latestUnitIds.length && latestVendorOptions.length) {
      const currentVendorItem = latestVendorOptions[0];
      const selectedVendorId = Number(vendorSelection[currentVendorItem?.key] || 0);
      const selectedVendor =
        currentVendorItem?.vendors?.find(
          (vendor) => Number(vendor.vendor_id) === selectedVendorId,
        ) || currentVendorItem?.vendors?.[0];
      derivedFromVendor = buildUnitIdPayload(
        selectedVendor?.unit_prices || [],
        selectedDataUnitIds,
      );
    }
    const sourcePrices =
      latestUnitIds.length > 0
        ? latestUnitIds
        : derivedFromVendor.length > 0
          ? derivedFromVendor
          : incomingPrices.length > 0
            ? incomingPrices
            : selectedDataUnitIds;
    const normalized = sourcePrices.map((u, idx) => ({
      id: getValue(u, ["id"], idx),
      start_range: Number(getValue(u, ["start_range", "StartRange"], 0)),
      end_range: Number(getValue(u, ["end_range", "EndRange"], 0)),
      marketplace_price: Number(
        getValue(u, ["marketplace_price", "Marketplace_price"], 0),
      ),
      vendor_price: Number(getValue(u, ["vendor_price", "Vendor_price"], 0)),
      raw: u,
    }));
    setUnitPrices(normalized);
    setShowUnitprice(true);
    setShowError("");
  };

  const handleClose = () => {
    setShowUnitprice(false);
  };

  const handleChange = (index, field, value) => {
    if (/^\d*\.?\d*$/.test(value)) {
      const updated = [...unitPrices];

      const maxAllowed =
        Number(updated[index].marketplace_price) -
        (Number(updated[index].marketplace_price) * Number(coupon || 0)) / 100;

      if (field === "vendor_price" && Number(value) > maxAllowed) {
        setShowError(`Vendor Price can't exceed ${maxAllowed} after coupon.`);
        return;
      }
      updated[index][field] = value;
      setUnitPrices(updated);
    }
    setShowError("");
  };

  const handleSave = async () => {
    try {
      const formattedUnitPrices = unitPrices.map((item) => ({
        id: Number(item.id),
        vendor_price: Number(item.vendor_price),
      }));
      const updatedUnitIds = buildUnitIdPayload(unitPrices, selectedData?.unit_ids);
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/update_unit_price`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            orderId: selectedData?.id,
            unit_price: formattedUnitPrices,
            unit_ids: updatedUnitIds,
          }),
        },
      );
      const data = await response.json();
      if (data.success) {
        setSelectedData((prev) =>
          prev ? { ...prev, unit_ids: updatedUnitIds } : prev,
        );
        setShowUnitprice(false);
      }
    } catch (error) {
      console.error("Error updating unit price", error);
    }
  };

  const cardSelectedHandler = (orderItem) => {
    getThreads(orderItem.ticket_id);
    setSelectedId(orderItem.ticket_id);
    setShowSelectedColor(true);
    setSelectedData(orderItem);
    setSelectedStatus("");
    setStatusError("");
    setSelectedTicket(orderItem.ticket_id);
    setVendorError("");
    setVendorSuccess("");
    setProceedMessage("");
    setIsVendorForwarded(false);
    if (orderType === "need_admin_approval") {
      fetchVendorOptions(orderItem.id);
    }
  };

  // REPLY FUNCTIONALITY :
  const handleReplySet = (value) => {
    setReplyValue(value);
  };

  const getThreads = (ticket) => {
    setThreadLoading(true);
    setIsPageLoading(false);
    if (ticket) {
      fetch(`${process.env.REACT_APP_SERVER_URL}/getAllThreads`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        method: "POST",
        body: JSON.stringify({
          ticket: ticket,
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            setThreadLoading(false);
            return response.json();
          } else if (response.status === 202) {
            setThreadLoading(false);
            console.log("token expired");
            navigate("/login", { state: { sessionExpired: true } });
            return;
          } else {
            setThreadLoading(false);
            console.log("Error");
            return response.json();
          }
        })
        .then((data) => {
          const tracking = Array.isArray(data?.tracking) ? data.tracking : [];
          setTrackingStatus(tracking);
          const latestStatus = getLatestTrackingStatus(tracking);
          setSelectedStatus(latestStatus || "");
          // setTimeout(scrollToTarget, 10);
          setThreadData(data.data);
          setIsPageLoading(false);
        })
        .catch((error) => console.log(error));
    } else {
      setThreadLoading(false);
    }
  };

  const handleSendReply = () => {
    try {
      setIsButtonLoading(true);
      if (replyValue.length !== 0) {
        fetch(`${process.env.REACT_APP_SERVER_URL}/sendReply`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
          method: "POST",
          body: JSON.stringify({
            selectedTicket: selectedTicket,
            selectedThread: selectedThread,
            replyValue: replyValue,
          }),
        })
          .then((response) => {
            if (response.status === 200) {
              setIsButtonLoading(false);
              return response.json();
            } else if (response.status === 202) {
              setIsButtonLoading(false);
              console.log("token expired");
              return;
            } else {
              setIsButtonLoading(false);
              return response.json();
            }
          })
          .then((data) => {
            getThreads(selectedData.ticket_id);
            setReplyValue("");
            setIsSomethingChanged(!isSomethingChanged);
          })
          .catch((error) => console.log(error));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const normalizeStatus = (status) =>
    String(status || "")
      .trim()
      .toLowerCase();

  const getTrackingEntryStatus = (entry) => {
    if (typeof entry === "string") return entry;
    if (!entry || typeof entry !== "object") return "";
    return getValue(
      entry,
      ["status", "currentStatus", "ticketStatus", "name", "Status"],
      "",
    );
  };

  const getTrackingEntryTime = (entry) => {
    if (!entry || typeof entry !== "object") return 0;
    const raw = getValue(
      entry,
      ["createdTime", "created_at", "updatedTime", "updated_at", "time"],
      "",
    );
    const t = new Date(raw).getTime();
    return Number.isNaN(t) ? 0 : t;
  };

  const getLatestTrackingStatus = (tracking) => {
    if (!Array.isArray(tracking) || tracking.length === 0) return "";
    const withStatus = tracking.filter(
      (entry) => normalizeStatus(getTrackingEntryStatus(entry)).length > 0,
    );
    if (!withStatus.length) return "";
    const byTime = [...withStatus].sort(
      (a, b) => getTrackingEntryTime(a) - getTrackingEntryTime(b),
    );
    return getTrackingEntryStatus(byTime[byTime.length - 1]);
  };

  const isNewOrderType = (type) => normalizeStatus(type) === "new";

  const getAllowedNextStatuses = (type, currentStatus) => {
    const normalizedCurrent = normalizeStatus(currentStatus);
    const newFlow = {
      open: ["In Progress"],
      "in progress": ["Invoice Generated", "Closed"],
      "invoice generated": ["Completed", "Closed"],
      completed: [],
      closed: [],
    };
    const addRemoveFlow = {
      open: ["In Progress"],
      "in progress": ["Update Subscription", "Closed"],
      "update subscription": ["Completed", "Closed"],
      completed: [],
      closed: [],
    };

    const flow = isNewOrderType(type) ? newFlow : addRemoveFlow;
    return flow[normalizedCurrent] || [];
  };

  const getStatusOptions = (type, currentStatus) => {
    const current = String(currentStatus || "").trim();
    const nextStatuses = getAllowedNextStatuses(type, currentStatus);
    return [current, ...nextStatuses].filter(Boolean);
  };

  const isValidStatusTransition = (type, fromStatus, toStatus) => {
    if (normalizeStatus(fromStatus) === normalizeStatus(toStatus)) return true;
    const allowed = getAllowedNextStatuses(type, fromStatus).map((s) =>
      normalizeStatus(s),
    );
    return allowed.includes(normalizeStatus(toStatus));
  };

  const getStatusColor = (status) => {
    if (status === "Completed") return "#15803d";
    if (status === "Closed") return "#dc2626";
    return "#111827";
  };

  const handleSaveStatus = async () => {
    if (!selectedData?.id || !selectedStatus) return;
    const currentStatus = getLatestTrackingStatus(trackingStatus);
    if (
      !isValidStatusTransition(selectedData?.type, currentStatus, selectedStatus)
    ) {
      setStatusError(
        `Invalid transition from "${currentStatus}" to "${selectedStatus}".`,
      );
      return;
    }
    try {
      setStatusError("");
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/update_status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            status: selectedStatus,
            ticketId: selectedData.ticket_id,
          }),
        },
      );

      const data = await response.json();
      if (data?.success || data?.status === 200) {
        getThreads(selectedData.ticket_id);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  return (
    <>
      {isPageLoading && <CardSkeletonTrackingDetail />}

      {!isPageLoading && (
        <div className={styles.wrapper}>
          <div className={tabStyles.TabbedContainer}>
            <div className={tabStyles.tabHeader}>
              <h1
                className={`${tabStyles.tab} ${
                  orderType === "order_approval" ? tabStyles.activeTab : ""
                }`}
                onClick={() =>
                  navigate("/dashboard/order_approval", {
                    state: { activeTab: "order_Appoval" },
                  })
                }
              >
                Order Approval
              </h1>
              <h1
                className={`${tabStyles.tab} ${
                  orderType === "need_admin_approval" ? tabStyles.activeTab : ""
                }`}
                onClick={() =>
                  navigate("/dashboard/order_approval", {
                    state: { activeTab: "need_Admin_Approval" },
                  })
                }
              >
                Need Admin Approval
              </h1>
            </div>
          </div>
          {/*BACK BUTTON*/}
          <div
            className={styles.backButton}
            onClick={() =>
              navigate("/dashboard/order_approval", {
                state: {
                  activeTab:
                    orderType === "need_admin_approval"
                      ? "need_Admin_Approval"
                      : "order_Appoval",
                },
              })
            }
          >
            <BsArrowLeftCircle
              style={{ fontSize: "24px", borderRadius: "50%" }}
            />
          </div>
          {/*MAIN CONTAINER*/}
          <div className={styles.mainContainer}>
            {/*Left PANEL - Tickets*/}
            <div className={styles.leftPanel}>
              <h5 className={styles.AllTicket}>All Tickets</h5>
              <ul
                id="ulId"
                ref={ulRef}
                className={styles.ticketList}
                style={{ flex: 1, overflowY: "auto" }}
              >
                {orders?.map((item) => {
                  const { id, marketplaceName, status, ticket_id, type } = item;
                  const isSelectedOn =
                    showSelectedColor && selectedId === ticket_id;
                  return (
                    <li
                      key={id}
                      // className={`min-h-[20%] w-[95%] bg-white  rounded shadow-md ${
                      //   isSelectedOn ? "border-2 border-blue-500" : ""
                      // }`}
                      className={`${styles.ticketItem} ${
                        isSelectedOn ? styles.ticketItemSelected : ""
                      }`}
                      onClick={() => {
                        cardSelectedHandler(item);
                        if (orderType === "need_admin_approval") {
                          fetchCouponPercent(item);
                        }
                        setReplyValue("");
                      }}
                      id="liId"
                      ref={liRef}
                    >
                      <div className={styles.ticketContent}>
                        <div className={styles.ticketTitle}>
                          {marketplaceName}
                          {type && (
                            <div className={styles.statusBadge}>{type}</div>
                          )}
                        </div>
                        <div className={styles.ticketID}>
                          Ticket ID : {ticket_id}
                        </div>
                        <div className={styles.statusBadge}>{status}</div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/*RIGHT PANEL - DETAILS*/}
            <div className={styles.rightPanel}>
              <h3 className={styles.AllTicket}>Ticket Details</h3>
              {threadData && selectedData && (
                <div className={styles.detailsCard}>
                  <div className={styles.detailsHeader}>
                    <div className={styles.ticketHeading}>
                      <LuMailCheck />
                      {selectedData.marketplaceName}
                      {selectedData.type && (
                        <span className={styles.statusBadge}>{selectedData.type}</span>
                      )}
                    </div>
                    <ul className={styles.metaList}>
                      <li>
                        Id : <span>{selectedData.id}</span>
                      </li>
                      <li>
                        Created Date :{" "}
                        <span style={{ color: "#969696" }}>
                          {threadData[0]?.createdTime
                            ?.split("T")[0]
                            ?.split("-")
                            ?.reverse()
                            ?.join("-")}
                        </span>{" "}
                      </li>
                      <li>
                        Created Time :{" "}
                        <span style={{ color: "#969696" }}>
                          {threadData[0]?.createdTime
                            ? new Date(
                                threadData[0].createdTime,
                              ).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                              })
                            : "N/A"}
                        </span>{" "}
                      </li>
                    </ul>
                    <div className={styles.actionsGrid}>
                      <div className={styles.actionCard}>
                        <p className={styles.actionTitle}>Ticket Status</p>
                        <div className={styles.selectWrapper}>
                        <select
                          className={styles.selectBox}
                          value={selectedStatus}
                          onChange={(e) => {
                            setSelectedStatus(e.target.value);
                            setStatusError("");
                          }}
                          style={{ color: getStatusColor(selectedStatus) }}
                        >
                          <option value="" disabled>
                            Select Status
                          </option>
                          {getStatusOptions(
                            selectedData.type,
                            getLatestTrackingStatus(trackingStatus),
                          ).map((status) => (
                            <option
                              key={status}
                              value={status}
                              style={{ color: getStatusColor(status) }}
                            >
                              {status}
                            </option>
                          ))}
                        </select>
                        <button
                          className={styles.updateBtn}
                          onClick={handleSaveStatus}
                        >
                          Save
                        </button>
                        </div>
                        {statusError && (
                          <p className={styles.inlineError}>{statusError}</p>
                        )}
                      </div>
                      {orderType === "need_admin_approval" && (
                        <div className={styles.actionCard}>
                          <p className={styles.actionTitle}>Need Admin Actions</p>
                          <div className={styles.updatePrice}>
                            <button
                              className={styles.updateBtn}
                              onClick={() => handleOpen(selectedData?.unit_ids)}
                              disabled={isVendorForwarded}
                            >
                              Update Price
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    {orderType === "need_admin_approval" && (
                      <div className={styles.vendorSection}>
                        <div className={styles.vendorSectionHeader}>
                          <p className={styles.actionTitle}>Vendor Assignment</p>
                          <button
                            className={styles.proceedBtn}
                            onClick={handleOpenProceedConfirm}
                            disabled={
                              proceedLoading || vendorLoading || isVendorForwarded
                            }
                          >
                            {/* Approving RELEASES the order: until then it is
                                held — nothing is placed with Ingram and the
                                ticket cannot move past In Progress. */}
                            {proceedLoading
                              ? "Approving..."
                              : isVendorForwarded
                                ? "Approved"
                                : "Approve & proceed"}
                          </button>
                        </div>
                        {vendorLoading && (
                          <div className={styles.loaderWrap}>
                            <CircularProgress size={20} />
                          </div>
                        )}
                        {!vendorLoading && vendorOptions.length === 0 && (
                          <p className={styles.inlineMuted}>
                            No vendor options available for this order.
                          </p>
                        )}
                        {!vendorLoading &&
                          vendorOptions.map((vendorItem) => {
                            const selectedVendor =
                              getSelectedVendorForItem(vendorItem);
                            const isChanging = vendorActionLoading[vendorItem.key];
                            return (
                              <div
                                key={vendorItem.key}
                                className={styles.vendorRowCard}
                              >
                                <div className={styles.vendorRowTop}>
                                  <div className={styles.vendorMeta}>
                                    <span>
                                      Price ID: {vendorItem.price_id || "N/A"}
                                    </span>
                                    <span>SKU: {vendorItem.sku_id || "N/A"}</span>
                                    <span>
                                      Assigned:{" "}
                                      {selectedVendor?.vendor_name ||
                                        getVendorNameFromId(
                                          vendorItem.vendors,
                                          vendorItem.assigned_vendor_id,
                                        )}
                                    </span>
                                  </div>
                                  <div className={styles.vendorActions}>
                                    <select
                                      className={styles.selectBox}
                                      value={vendorSelection[vendorItem.key] || ""}
                                      disabled={isVendorForwarded}
                                      onChange={(e) =>
                                        handleVendorSelectionChange(
                                          vendorItem.key,
                                          e.target.value,
                                        )
                                      }
                                    >
                                      <option value="" disabled>
                                        Select Vendor
                                      </option>
                                      {vendorItem.vendors.map((vendor) => (
                                        <option
                                          key={vendor.key}
                                          value={String(vendor.vendor_id)}
                                        >
                                          {vendor.vendor_id === -1
                                            ? "Admin-owned"
                                            : vendor.vendor_name}
                                          {vendor.is_default ? " (Default)" : ""}
                                        </option>
                                      ))}
                                    </select>
                                    <button
                                      className={styles.updateBtn}
                                      onClick={() => handleOpenVendorConfirm(vendorItem)}
                                      disabled={isChanging || isVendorForwarded}
                                    >
                                      {isChanging ? "Updating..." : "Change Vendor"}
                                    </button>
                                  </div>
                                </div>
                                {selectedVendor?.unit_prices?.length > 0 && (
                                  <div className={styles.vendorPriceGrid}>
                                    {selectedVendor.unit_prices.map((unit, idx) => (
                                      <div
                                        key={getValue(unit, ["id", "unit_id"], idx)}
                                        className={styles.vendorPriceChip}
                                      >
                                        <span>
                                          {getValue(unit, ["start_range", "StartRange"], 0)}
                                          -
                                          {getValue(unit, ["end_range", "EndRange"], 0)}
                                        </span>
                                        <span>
                                          VP:{" "}
                                          {getValue(
                                            unit,
                                            ["vendor_price", "Vendor_price"],
                                            0,
                                          )}
                                        </span>
                                        <span>
                                          MP:{" "}
                                          {getValue(
                                            unit,
                                            ["marketplace_price", "Marketplace_price"],
                                            0,
                                          )}
                                        </span>
                                        {Boolean(
                                          getValue(
                                            unit,
                                            ["show_default", "showDefault"],
                                            false,
                                          ),
                                        ) && <span>Default</span>}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        {vendorError && (
                          <p className={styles.inlineError}>{vendorError}</p>
                        )}
                        {vendorSuccess && (
                          <p className={styles.inlineSuccess}>{vendorSuccess}</p>
                        )}
                        {proceedMessage && (
                          <p className={styles.inlineSuccess}>{proceedMessage}</p>
                        )}
                        {isVendorForwarded && (
                          <p className={styles.inlineMuted}>
                            Vendor assignment is locked after forwarding this order.
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <ArrayStepper trackingStatus={trackingStatus} />
                  </div>
                </div>
              )}
              {threadLoading && <div>{<CircularProgress size={25} />}</div>}
              <div className={styles.threadContainer}>
                {!threadLoading && (
                  <ul className={styles.threadList}>
                    {Array.isArray(threadData) &&
                      threadData.map((item) => (
                        <li key={item.id} className={styles.threadItem}>
                          <div
                            className={styles.threadContent}
                            dangerouslySetInnerHTML={{ __html: item.content }}
                          />
                        </li>
                      ))}
                  </ul>
                )}

                {/* REPLY FUNCTIONALITY  */}
                <div className={styles.replySection}>
                  <TextField
                    value={replyValue}
                    onChange={(e) => {
                      handleReplySet(e.target.value);
                    }}
                    fullWidth
                    label="Send a Message"
                  />
                  <div
                    className={styles.replyButton}
                    onClick={(e) => {
                      setSelectedThread(threadData[0].id);
                      handleSendReply();
                    }}
                  >
                    {isButtonLoading ? (
                      <CircularProgress size={20} className="text-white" />
                    ) : (
                      <div style={{ width: "100%" }}>
                        <UTurnLeftIcon className={styles.ReplyArrow} />
                        <span>Reply</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showUnitPrice && (
        <Dialog
          open={showUnitPrice}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              minHeight: "72vh",
              maxHeight: "86vh",
            },
          }}
        >
          <DialogTitle>Update Unit Prices</DialogTitle>
          <DialogContent dividers sx={{ pt: 2 }}>
            {unitPrices.map((item, index) => (
              <Box
                key={index}
                sx={{
                  border: "1px solid #E4E7EC",
                  borderRadius: "12px",
                  padding: "14px",
                  marginBottom: "12px",
                  background: "#FAFBFC",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                    gap: 1,
                    mb: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      background: "#F2F4F7",
                      borderRadius: "10px",
                      px: 1.25,
                      py: 0.9,
                    }}
                  >
                    <Typography
                      sx={{ fontSize: "11px", color: "#667085", mb: 0.25 }}
                    >
                      Start Range
                    </Typography>
                    <Typography sx={{ fontSize: "15px", fontWeight: 600 }}>
                      {item.start_range}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      background: "#F2F4F7",
                      borderRadius: "10px",
                      px: 1.25,
                      py: 0.9,
                    }}
                  >
                    <Typography
                      sx={{ fontSize: "11px", color: "#667085", mb: 0.25 }}
                    >
                      End Range
                    </Typography>
                    <Typography sx={{ fontSize: "15px", fontWeight: 600 }}>
                      {item.end_range}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      background: "#F2F4F7",
                      borderRadius: "10px",
                      px: 1.25,
                      py: 0.9,
                    }}
                  >
                    <Typography
                      sx={{ fontSize: "11px", color: "#667085", mb: 0.25 }}
                    >
                      Marketplace Price
                    </Typography>
                    <Typography sx={{ fontSize: "15px", fontWeight: 600 }}>
                      {item.marketplace_price}
                    </Typography>
                  </Box>
                </Box>
                <TextField
                  label="Vendor Price"
                  type="number"
                  value={item.vendor_price}
                  onChange={(e) =>
                    handleChange(index, "vendor_price", e.target.value)
                  }
                  fullWidth
                  helperText={`Max allowed after coupon: ${
                    Number(item.marketplace_price) -
                    (Number(item.marketplace_price) * Number(coupon || 0)) / 100
                  }`}
                />
              </Box>
            ))}
            <p style={{ color: "red", fontSize: "14px", textAlign: "center" }}>
              {showError}
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Dialog
        open={confirmVendorDialogOpen}
        onClose={handleCloseVendorConfirm}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Vendor Change</DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ fontSize: "14px" }}>
            {pendingVendorItem
              ? `Change vendor for SKU ${pendingVendorItem.sku_id || "N/A"} to ${
                  getSelectedVendorForItem(pendingVendorItem)?.vendor_name ||
                  "selected vendor"
                }?`
              : "Do you want to change vendor?"}
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#B45309", mt: 1 }}>
            Once vendor is changed, all prices and calculated amounts in this
            order will be updated.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseVendorConfirm}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleConfirmVendorChange}
            disabled={
              !pendingVendorItem ||
              Boolean(vendorActionLoading[pendingVendorItem?.key])
            }
          >
            {pendingVendorItem && vendorActionLoading[pendingVendorItem.key]
              ? "Updating..."
              : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmProceedDialogOpen}
        onClose={handleCloseProceedConfirm}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Approve this order?</DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ fontSize: "14px" }}>
            It is released at the vendor cost shown — set it first if you need
            to; it is locked once approved. An Ingram order is placed with
            Ingram straight away; any other order moves on when you move its
            ticket.
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#475467", mt: 1 }}>
            The order also shows in the selling vendor's portal (not for an
            Easexpense-sold order).
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseProceedConfirm} disabled={proceedLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmProceedToVendor}
            disabled={proceedLoading}
          >
            {proceedLoading ? "Approving..." : "Approve & proceed"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TrackingDetails;
